// extracted by mini-css-extract-plugin
export default {"background":"background_background__+-s3+","background_grey":"background_background_grey__P3rHu"};